/**
 * @description 列的过滤项配置, 丰富表格过滤能力
 * 1. 内置下拉框搜索
 * 2. 内置input
 * 3. 支持自定义组件插槽
 */

import {
  IInputProps,
  ISelectOpt,
  ISelectOptionItem,
} from '@tencent/udesign/dist';
import React from 'react';

interface ITableFilterBasic<T> {
  /**
   * @param value 过滤项得到的值
   * @param record 每行的数据
   * @returns 最终结果返回过滤之后的列表
   */
  readonly onFilter?: (value: any, record: T) => boolean;
}

export enum TableFilterMode {
  'menu' = 'menu',
  'input' = 'input',
  'custom' = 'custom',
}

export interface ITableFilterMenu<T> extends ITableFilterBasic<T> {
  readonly kind: TableFilterMode.menu;
  readonly options: ReadonlyArray<ISelectOptionItem>;
  readonly icon?: React.ReactNode;
  readonly multiple?: boolean;
  readonly extension?: ISelectOpt<any>;
}

export interface ITableFilterInput<T> extends ITableFilterBasic<T> {
  readonly kind: TableFilterMode.input;
  readonly extension?: IInputProps;
}

export interface ITableFilterCustom<T> extends ITableFilterBasic<T> {
  readonly kind: TableFilterMode.custom;
  readonly children: (
    onChanged: (value: string) => void,
    value: string | string[]
  ) => React.ReactNode;
  readonly icon?: React.ReactNode;
}

export type TableFilter<T> =
  | ITableFilterMenu<T>
  | ITableFilterInput<T>
  | ITableFilterCustom<T>;
